import _ from "lodash";
import { PERMISSION_TYPES } from "./sf_constants";
import { FEATURES, INTEGRATIONS_FEATURE_GROUP_ID } from "pages/Roles/newFeaturesAndPermissionsData";

// BM-9524: a fresh copy of the role builder groups. The Integrations group is left
// out unless the both::integration_role_permissions flag is on for the account,
// so saving a role then never sends (and never overwrites) features 21/24.
export const getRoleBuilderFeatures = (includeIntegrations) => _.cloneDeep(
  FEATURES.filter(group => includeIntegrations || group.id !== INTEGRATIONS_FEATURE_GROUP_ID)
);

export const permissionArrayToObject = (arr, isActive) => {
  let permissionObject = {
      [PERMISSION_TYPES.CREATE]: false,
      [PERMISSION_TYPES.READ]: false,
      [PERMISSION_TYPES.UPDATE]: false,
      [PERMISSION_TYPES.DELETE]: false,
  }

  if (!isActive) {
      return permissionObject;
  }

  for(let perm of arr) {
      permissionObject[perm] = true;
  }

  return permissionObject;
}

export const isManageType = (permission) => {
  if (permission.types.length === 1) {
      return false;
  }

  return true;
}

export const getRoleUIState = (roleObj, initialUIState) => {
  const initialUIStateClone = _.cloneDeep(initialUIState);
  const existingPermissions = roleObj.permissions;

  for (let featureGroup of initialUIStateClone) {
    let isFeatureGroupActive = false;
    for (let perm of featureGroup.permissions) {
      const isPermManageType = isManageType(perm);
      const isPermActive = getPermActive(perm, existingPermissions, isPermManageType);

      perm.isActive = isPermActive;
      isFeatureGroupActive = isFeatureGroupActive || isPermActive;
    }
    featureGroup.isActive = isFeatureGroupActive;
  }

  return initialUIStateClone;
}

const getPermActive = (permission, backendPermissions, isManageType) => {
  const feature_ids = permission.features.map(feature => feature.feature_id);
  const relevantBackendPermissions = backendPermissions.filter(perm => feature_ids.includes(perm.feature_id));
  if (feature_ids.length !== relevantBackendPermissions.length) {
    return false;
  }

  if(isManageType) {
    for (const perm of relevantBackendPermissions) {
      if (!perm[PERMISSION_TYPES.CREATE] || !perm[PERMISSION_TYPES.READ] || !perm[PERMISSION_TYPES.UPDATE] || !perm[PERMISSION_TYPES.DELETE]) {
        return false;
      }
    }
  } else {
    for (const perm of relevantBackendPermissions) {
      if (!perm[PERMISSION_TYPES.READ]) {
        return false;
      }
    }
  }
  return true;
}

